import moment from 'moment'

export { formatNumberAsUSD, formatNumberAsUSDNoCents, momentDateTime, momentDateTimeShort }

function momentDateTime(value) {
  if (!value) return ''
  return moment(value).format('LLLL')
}

function momentDateTimeShort(value) {
  if (!value) return ''
  return moment(value).format('LLL')
}

function formatNumberAsUSD(value) {
  if (!value) return 0
  return Number(value).toLocaleString('en', {
    style: 'currency',
    currency: 'USD',
  })
}

function formatNumberAsUSDNoCents(value) {
  if (!value) return 0
  return Number(value)
    .toLocaleString('en', {
      style: 'currency',
      currency: 'USD',
    })
    .slice(0, -3)
}
